<template>
    <section class="qrcode-checkout-container" v-if="!productUnset">
      <FloatingHeader :title="'Confirme sua identidade'" :sbtitle="''" :showHeader="true"
      :hideSearch="true" :hideArrowBack="true"></FloatingHeader>
      <h1>Estamos quase lá!</h1>
      <p>Informe seu e-mail e telefone para continuar a compra.</p>

        <div class="qrcode-checkout">
            <div class="qrcode-checkout-data">
                <label for="email" class="required">E-mail: </label>
                <input type="email" id="email" name="email" placeholder="E-mail" v-model="email"/>
            </div>
            <div class="qrcode-checkout-data">
                <label for="phone" class="required">Telefone: </label>
                <input type="tel" id="phone" name="phone" placeholder="Telefone (com DDD)" v-model="phone" v-mask="'(00) 00000-0000'"/>
            </div>
            <div class="qrcode-checkout-button" v-if="!loading">
                <DefaultButton v-for="(but, bKey) in buttons" :key="bKey" :text="but.display" @defaultBtnClick="but.action && but.action()"></DefaultButton>
            </div>
        </div>
    </section>

    <ScreenLoader :isLoading="loading" />
    <ModalInfo></ModalInfo>
</template>

<script>
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/buttons/DefaultButton.vue'
import FloatingHeader from '@/components/FloatingHeader.vue'
import ModalInfo from '@/components/modals/ModalInfo.vue'
import ScreenLoader from '@/components/loader/ScreenLoader.vue'
import { mapActions } from 'vuex'
// import cardapio from '@/assets/mock/cachedFoodMenuHells'
import { sendOtp } from '@/assets/controllers/ConsumerController'

export default {
  name: 'QrCodeCheckoutView',
  components: {
    FloatingHeader,
    DefaultButton,
    ModalInfo,
    ScreenLoader
  },
  data () {
    return {
      email: '',
      phone: '',
      buttons: [
        {
          display: 'Continuar',
          fill: true,
          action: this.confirmCodeView
        }
      ],
      loading: false,
      productId: '',
      productUnset: false
    }
  },
  computed: {
  },
  methods: {
    ...mapActions(['setMenu', 'setUserContact', 'showModalInfo']),
    confirmCodeView: function () {
      if (!this.checkFields()) {
        return
      }
      this.sendOtp()
    },
    sendOtp: function () {
      const data = {
        email: this.email,
        phone: this.phone
      }
      this.loading = true
      sendOtp(data).then((response) => {
        this.loading = false

        if (response.error) {
          let userMessage = 'Erro ao enviar o código. Verifique os dados e tente novamente.'

          if (response.message.includes('consumidor já está cadastrado')) {
            userMessage = 'Os dados não conferem. Por favor, informe o e-mail e o celular utilizados em acessos anteriores.'
          } else if (response.message.includes('Erro na comunicação com API externa')) {
            userMessage = 'Erro de comunicação com o sistema. Tente novamente mais tarde.'
          }

          this.showModalInfo({
            type: 'error',
            text: userMessage,
            open: true
          })
          return null
        }

        if (!(response.message?.email?.status === 'SUCCESS' || response.message?.phone?.status === 'SUCCESS')) {
          this.showModalInfo({
            type: 'error',
            text: 'Não foi possível enviar o código. Verifique os dados e tente novamente.',
            open: true
          })
          return null
        }

        this.setUserContact(data)

        this.$router.push({
          name: 'confirmcode',
          query: { productId: this.productId }
        })
      }).catch((error) => {
        console.error(error)
        Util.showErrorNotification({
          title: 'Erro ao enviar o código. Verifique os dados e tente novamente.',
          text: ''
        })
        this.loading = false
      })
    },
    checkFields: function () {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      const phoneRegex = /^\(\d{2}\)\s\d{5}-\d{4}$/

      if (!this.email || !this.phone) {
        Util.showWarningNotification({
          title: 'Preencha todos os campos.',
          text: ''
        })
        return false
      }

      if (!emailRegex.test(this.email)) {
        Util.showWarningNotification({
          title: 'E-mail inválido.',
          text: ''
        })
        return false
      }

      if (!phoneRegex.test(this.phone)) {
        Util.showWarningNotification({
          title: 'Telefone inválido. Use o formato (00) 00000-0000.',
          text: ''
        })
        return false
      }

      return true
    }

  },
  mounted () {
    this.productUnset = this.$route.params.productId === 'unset'

    if (!this.productUnset) {
      // const menu = cardapio.data
      // this.setMenu(menu)
      this.productId = this.$route.params.productId
    }
  }
}
</script>

<style lang="less" scoped>
.qrcode-checkout-container {
    padding: 60px 20px 170px 20px;

    .qrcode-checkout {
        margin-top: 10%;
        .qrcode-checkout-data{
            margin-bottom: 30px;
            label {
                display: block;
                position: relative;
                margin-bottom: 15px;
                &.required:after{
                    content: '*';
                    color: red;
                    margin-left: 5px;
                }
            }
            input:not([type="checkbox"]) {
                width: calc(100% - 20px);
                padding: 15px 10px;
                font-size: 16px;
                border: 1px solid rgba(0, 0, 0, 0.2);
                border-radius: 7px;
                margin-top: 10px;
            }
        }
        .error-password {
            text-align: center;
            color: red;
        }
        .qrcode-checkout-button {
          position: fixed;
          display: flex;
          justify-content: center;
          width: -webkit-fill-available;
          bottom: 0;
          left: 0;
          padding: 10px 0 40px 0;

          button {
            display: block;
            min-width: 80vw !important;
            height: 55px !important;
            margin: 5px !important;
            border: none;
            background: var(--primaryColor);
            color: white;
          }
        }
    }

    .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 40px;
        i {
            font-size: 40px;
            color: var(--primaryColor);
        }
    }
}
</style>
